import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { DigitalCard } from '../components/carte/DigitalCard';
import { FamilySection } from '../components/carte/FamilySection';
import { PetsSection } from '../components/carte/PetsSection';
import { ConsentDialog, EditCardDialog } from '../components/carte/EditCardDialog';
import type { FamilyMember } from '../data/carte';
export function MaCarte() {
  const [memberId, setMemberId] = useState('bryon');
  const [editing, setEditing] = useState<FamilyMember | null>(null);
  const [consent, setConsent] = useState<FamilyMember | null>(null);
  const openEdit = (member: FamilyMember) => {
    if (member.canEdit) setEditing(member);else setConsent(member);
  };
  return <main className="bg-white" data-id="element-2015" data-mp="1nzlzopykh4xb">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2016" data-mp="1o2ros57746t1">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2017" data-mp="1sxxbv7cc3rip">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-2018" data-mp="2pukiwkr3iq6w">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2019" data-mp="2lro5d8gexk9t" />
          <span aria-current="page" data-id="element-2020" data-mp="2gsuor75txd5f">My Card</span>
        </nav>

        <header className="mt-4" data-id="element-2021" data-mp="2bvuk90omoigf">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2022" data-mp="2but6upk53jvj">My Card</h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-2023" data-mp="26xt3imeocv84">
            Your digital citizen card gets you into Town services, for you and for the members of your family.
          </p>
        </header>

        <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,460px)_minmax(0,1fr)] lg:gap-14" data-id="element-2024" data-mp="1y1jz0tbub6f4">
          <DigitalCard memberId={memberId} onEdit={openEdit} data-id="element-2025" data-mp="1t30e8w8zg0oc" />
          <div data-id="element-2026" data-mp="1o58mq3c92gko">
            <FamilySection selectedId={memberId} onSelect={setMemberId} data-id="element-2027" data-mp="1o4yz2meogli5" />
            <PetsSection data-id="element-2028" data-mp="1j7ynjvz26qjn" />
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-2029" data-mp="19iicgcgjtdmy">
        {editing && <EditCardDialog member={editing} onClose={() => setEditing(null)} data-id="element-2030" data-mp="19hgnd42p6qm8" />}
      </AnimatePresence>
      <AnimatePresence data-id="element-2031" data-mp="1ejpjg9ava8sk">
        {consent && <ConsentDialog member={consent} onClose={() => setConsent(null)} data-id="element-2032" data-mp="1efs0pos7bj97" />}
      </AnimatePresence>
    </main>;
}